import React from "react";

// Custom brand logo for INDIAN-NEWS-21
// Uses the generated /logo.png with graceful text fallback.
export default function BrandLogo({ size = 44, showText = false, textColor = "#0F172A", className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} style={{ width: size, height: size }}>
      <img
        src="/logo.png"
        alt="INDIAN-NEWS-21"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", display: "block" }}
        className="rounded-md shadow-sm bg-white"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-devnagri-heading font-black tracking-tight" style={{ color: textColor, fontSize: size * 0.42 }}>
            INDIAN-NEWS-21
          </div>
          <div className="text-[10px] uppercase tracking-widest font-admin" style={{ color: textColor === "#FFFFFF" ? "#94A3B8" : "#64748B" }}>
            भारत की आवाज़
          </div>
        </div>
      )}
    </div>
  );
}
